import { useEffect, useState } from "react";

/**
 * "Coming Q4 2027" countdown ribbon. Computes a live ticker to a fixed
 * release target. Pure visual hype banner — no API.
 */

const TARGET = new Date("2027-10-01T13:30:00Z").getTime(); // Oct 1, 2027, NYSE open ET

function diff(now) {
  let s = Math.max(0, Math.floor((TARGET - now) / 1000));
  const d = Math.floor(s / 86400); s -= d * 86400;
  const h = Math.floor(s / 3600);  s -= h * 3600;
  const m = Math.floor(s / 60);    s -= m * 60;
  return { d, h, m, s };
}

export default function ComingSoonRibbon() {
  const [t, setT] = useState(diff(Date.now()));

  useEffect(() => {
    const iv = setInterval(() => setT(diff(Date.now())), 1000);
    return () => clearInterval(iv);
  }, []);

  const cells = [
    { v: t.d, l: "DAYS" },
    { v: t.h, l: "HOURS" },
    { v: t.m, l: "MIN" },
    { v: t.s, l: "SEC" },
  ];

  return (
    <section data-testid="coming-soon-ribbon" style={{
      padding: "30px 24px 60px", maxWidth: 980, margin: "0 auto", width: "100%", boxSizing: "border-box",
    }}>
      <div style={{
        position: "relative", overflow: "hidden",
        padding: "28px 28px",
        borderRadius: 20,
        background: "linear-gradient(120deg, rgba(167,139,250,0.10), rgba(96,165,250,0.06), rgba(74,222,128,0.04))",
        border: "1px solid rgba(167,139,250,0.20)",
        backdropFilter: "blur(10px)",
      }}>
        {/* Animated scan line */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(90deg, transparent, rgba(167,139,250,0.18), transparent)",
          backgroundSize: "200% 100%",
          animation: "comingScan 6s linear infinite",
          pointerEvents: "none",
        }} />
        <style>{`
          @keyframes comingScan { 0%{background-position:-100% 0} 100%{background-position:200% 0} }
          @keyframes flipIn { 0%{transform:rotateX(-90deg);opacity:0} 100%{transform:rotateX(0);opacity:1} }
        `}</style>

        <div style={{ textAlign: "center", marginBottom: 18, position: "relative" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: 8, padding: "5px 14px",
            borderRadius: 999, background: "rgba(167,139,250,0.14)",
            border: "1px solid rgba(167,139,250,0.32)", marginBottom: 10,
          }}>
            <span style={{ width: 6, height: 6, borderRadius: 3, background: "#a78bfa", animation: "pulse 1.6s infinite" }} />
            <span style={{ fontSize: 10, fontWeight: 800, color: "#a78bfa", letterSpacing: 2.5 }}>
              FULL RELEASE · Q4 2027
            </span>
          </div>
          <h3 style={{ fontSize: 22, fontWeight: 800, color: "#e6edf3", letterSpacing: -0.4, margin: "6px 0 4px" }}>
            The platform unlocks October 2027.
          </h3>
          <div style={{ fontSize: 13, color: "#8b949e" }}>
            Waitlist members get private beta access in <strong style={{ color: "#a78bfa" }}>Q2 2027</strong>.
          </div>
        </div>

        <div style={{
          display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10,
          maxWidth: 560, margin: "0 auto", position: "relative",
        }}>
          {cells.map((c, i) => (
            <div key={c.l} style={{
              padding: "16px 8px", textAlign: "center",
              borderRadius: 14,
              background: "rgba(0,0,0,0.35)",
              border: "1px solid rgba(255,255,255,0.08)",
            }}>
              <div data-testid={`countdown-${c.l.toLowerCase()}`} style={{
                fontSize: 30, fontWeight: 800, color: "#e6edf3",
                letterSpacing: -0.5, fontVariantNumeric: "tabular-nums",
                animation: i === 3 ? "flipIn 1s ease" : undefined,
                animationIterationCount: i === 3 ? "infinite" : undefined,
                animationDuration: i === 3 ? "1s" : undefined,
              }}>{String(c.v).padStart(2, "0")}</div>
              <div style={{ fontSize: 9, color: "#8b949e", letterSpacing: 2, marginTop: 4 }}>{c.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
